import { getConnectivity } from '@datadog/browser-core';
export function startConnectivityContext(hooks) {
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => ({
        type: eventType,
        connectivity: getConnectivity(),
    }));
}
//# sourceMappingURL=connectivityContext.js.map